/**
 * 员工管理 API
 */
import http from './httpRequest.js'

/**
 * 获取员工列表
 */
export function getEmployeeList(params = {}) {
  return http({
    url: '/employee/list',
    method: 'GET',
    params
  })
}

/**
 * 获取员工详情
 */
export function getEmployeeById(id) {
  return http({
    url: `/employee/${id}`,
    method: 'GET'
  })
}

/**
 * 新增员工
 */
export function addEmployee(data) {
  return http({
    url: '/employee/add',
    method: 'POST',
    data
  })
}

/**
 * 更新员工
 */
export function updateEmployee(data) {
  return http({
    url: '/employee/update',
    method: 'PUT',
    data
  })
}

/**
 * 启用/禁用员工
 */
export function toggleEmployeeStatus(id) {
  return http({
    url: `/employee/toggleStatus/${id}`,
    method: 'PUT'
  })
}

/**
 * 删除员工
 */
export function deleteEmployee(id) {
  return http({
    url: `/employee/${id}`,
    method: 'DELETE'
  })
}

/**
 * 分配角色
 */
export function assignRole(userId, role) {
  return http({
    url: '/employee/assignRole',
    method: 'PUT',
    data: { userId, role }
  })
}

/**
 * 获取角色列表
 */
export function getRoleList() {
  return http({
    url: '/employee/role/list',
    method: 'GET'
  })
}
